import Auth from './index';



export default {
    //the prefix route for this layout
    path: '/auth',
    //the component to render for this layout
    component: Auth
} 